module.exports = __webpack_public_path__ + "static/media/strek.230c0b31.m4a";